import { render } from "./MenuDividerLine.vue?vue&type=template&id=16d2a372&scoped=true"
import script from "./MenuDividerLine.vue?vue&type=script&lang=js"
export * from "./MenuDividerLine.vue?vue&type=script&lang=js"

import "./MenuDividerLine.vue?vue&type=style&index=0&id=16d2a372&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d2a372"]])

export default __exports__